import { IDeviceChannel } from 'lavva.exalushome/build/js/Services/Devices/IDeviceChannel';

export const getValueFromChannelCustomData = (key: string, channel: IDeviceChannel) => channel.CustomData[key];
